var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.role_id == 100 || _vm.role_id == 2 || _vm.role_id == 7)?_c('commercial-dashboard'):(_vm.role_id == 6)?_c('customer-dashboard'):_c('default-dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }